
const ShareEnvironmentIcon = () => {
  return(
      <svg id="Component_3803_1" data-name="Component 3803 – 1" xmlns="http://www.w3.org/2000/svg" width="26" height="16" viewBox="0 0 26 16">
          <g>
              <g>
                  <path className="st0" fill={"#838383"} d="M14.5,13.3c0,0.5-0.4,0.9-0.9,0.9H3.2c-0.5,0-0.9-0.4-0.9-0.9c0-2.6,2.1-4.7,4.7-4.7h2.8
			C12.4,8.5,14.5,10.7,14.5,13.3z M13.6,13.3c0-2.1-1.7-3.9-3.9-3.9H7c-2.1,0-3.9,1.7-3.9,3.9c0,0,0,0.1,0.1,0.1L13.6,13.3
			C13.6,13.3,13.6,13.3,13.6,13.3z M4.9,3.7c0-1.9,1.6-3.5,3.5-3.5s3.5,1.6,3.5,3.5s-1.6,3.5-3.5,3.5S4.9,5.7,4.9,3.7z M5.7,3.7
			c0,1.4,1.2,2.6,2.6,2.6S11,5.2,11,3.7S9.8,1.1,8.4,1.1C6.9,1.1,5.7,2.3,5.7,3.7z"/>
              </g>
              <rect id="Rectangle_78801" x="12.4" y="8" fill={"#FFFFFF"} className="st1" width="7" height="6"/>
              <g>
                  <path className="st2" fill={"#EC407A"} d="M19.3,6.6c0.7,0,1.2,0.6,1.2,1.2v6.2c0,0.7-0.6,1.2-1.2,1.2h-6.2c-0.7,0-1.2-0.6-1.2-1.2V7.8
			c0-0.7,0.6-1.2,1.2-1.2H19.3z M18.1,7.8c-0.7,0-1.2,0.6-1.2,1.2c0,0,0,0.1,0,0.1l-1.6,0.9c-0.2-0.2-0.6-0.4-0.9-0.4
			c-0.7,0-1.2,0.6-1.2,1.2s0.6,1.2,1.2,1.2c0.4,0,0.7-0.2,0.9-0.4l1.6,0.9c0,0,0,0.1,0,0.1c0,0.7,0.6,1.2,1.2,1.2s1.2-0.6,1.2-1.2
			s-0.6-1.2-1.2-1.2c-0.3,0-0.6,0.1-0.8,0.3l-1.7-0.9l1.7-0.9c0.2,0.2,0.5,0.3,0.8,0.3c0.7,0,1.2-0.6,1.2-1.2S18.8,7.8,18.1,7.8z"/>
              </g>
          </g>
      </svg>

  );

}
export default ShareEnvironmentIcon;
